<template>
    <div class="popup">
        <div
            class="popup-cover"
            @click.stop="closePopup"
        ></div>
        <div class="popup-con">
            <div class="appointment-icon">
                <img :src="bookSuccess" alt="">
            </div>
            <div class="close-icon">
                <img :src="popupClose" alt="" @click.stop="closePopup">
            </div>
            <div class="title">预约成功</div>
            <div
                class="hint"
            >
                点击下方按钮抽超燃测试资格
            </div>
            <div class="btn" @click="actGameBooked">
                <span>参与抽奖</span>
            </div>
        </div>
    </div>
</template>

<script>
    import bookSuccess from 'public/assets/imgs/book_success.png';
    import popupClose from 'public/assets/imgs/close_popup.png';
    export default {
        props: {
            url: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                bookSuccess: bookSuccess,
                popupClose: popupClose
            }
        },
        created() {
            this.doDisplayLog();
        },
        methods: {
            closePopup() {
                this.$emit('closeSuccessCard');
            },
            actGameBooked() {
                setTimeout(() => {
                    location.href = this.url;
                }, 100);
                this.doClickLog();
            },
            doClickLog() {
                this.$logger.click(this.genLogContent());
            },
            doDisplayLog() {
                this.$logger.display(this.genLogContent());
            },
            genLogContent(body = {}) {
                const content = {
                    value: 'jumpBtn',
                    ext: {
                        id: '',
                        ext: Object.assign({
                            booked: false,
                            ...body
                        }, this.$root.extData),
                        pos: ''
                    }
                }
                return content;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;
    .popup {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10000;
        .popup-cover {
            background-color: #000000;
            opacity: 0.65;
            width: 100%;
            height: 100%;
        }
        .popup-con {
            position: absolute;
            width: px2rem(993);
            height: px2rem(729);
            background-color: #fff;
            left: 50%;
            transform: translateX(-50%);
            top: px2rem(792);
            border-radius: px2rem(39);
            .appointment-icon {
                position: relative;
                img {
                    position: absolute;
                    width: px2rem(594);
                    height: pxrem(283);
                    left: 50%;
                    transform: translateX(-50%);
                    top: px2rem(-93.05);
                }
            }
            .close-icon{
                position: relative;
                img {
                    position: absolute;
                    width: px2rem(36);
                    height: px2rem(36);
                    top: px2rem(36);
                    right: px2rem(36);
                }
            }
            .title {
                font-size: px2rem(63);
                line-height: px2rem(63);
                text-align: center;
                margin-top: px2rem(249);
                color: #333;
            }
            .hint {
                font-size: px2rem(48);
                text-align: center;
                line-height: px2rem(48);
                margin-top: px2rem(60);
                color: #858585;
            }
            .btn {
                position: absolute;
                width: px2rem(572);
                height: px2rem(128);
                border-radius: px2rem(66);
                background-color: #FF834F;
                left: 50%;
                transform: translateX(-50%);
                margin-top: px2rem(90);
                text-align: center;
                font-size: px2rem(48);
                line-height: px2rem(128);
                color: #fff;
                font-weight: 500;
            }  
        }
    }
</style>